import React from 'react';
import './Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

// header js file

const Header = () => {
    return (
        <div className='d-flex justify-content-around menu-bar backcolor'>
            <div >
                <h2 className='logo'>My Portfolio</h2>
            </div>
            <div className='all-nav'>
                <Link className='link' to='/home'>Home</Link>
                <Link className='link' to='/banner'>Banner</Link>
                <Link className=' link' to='/about'>About</Link>
                <Link className=' link' to='/project'>Project</Link>
                <Link className=' link' to='/blog'>Blogs</Link>
                <Link className=' link' to='/contact'>Contact</Link>
            </div>
        </div>

    );
};

export default Header;